import { ANNOTATION_TYPE, DRAFT_ANNOTATION_UUID } from "./annotation.constant";
import { ANNOTATION_RICHTEXT_EDITOR_OPTIONS } from "@plugins/richtext/richtext.constant.ts";

interface AnnotationEditorTarget {
  uuid?: string;
  type?: string;
}

export function shouldUseInlineAnnotationEditor(
  annotation: AnnotationEditorTarget | null | undefined,
  initialOptionType = "",
  isInNotebook = false,
): boolean {
  return (
    !isInNotebook &&
    annotation?.uuid === DRAFT_ANNOTATION_UUID &&
    annotation.type === ANNOTATION_TYPE.TEXT_ANNOTATION &&
    (initialOptionType === "" ||
      initialOptionType === ANNOTATION_RICHTEXT_EDITOR_OPTIONS.RECORDING ||
      initialOptionType === ANNOTATION_RICHTEXT_EDITOR_OPTIONS.DRAWING)
  );
}
